import RoomCatalog from './RoomCatalog'

export default RoomCatalog



// WEBPACK FOOTER //
// ./src/features/Hotel/containers/RoomCatalog/index.js